import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    selected: null
};

const rangeSlice = createSlice({
    name: 'range',
    initialState,
    reducers: {
        setSelected: (state, {payload}) => { state.selected = payload; },
        resetRange: (state) => { state.selected =  null; }
    }
});

export const {
    setSelected,
    resetRange
    
} = rangeSlice.actions;

export default rangeSlice.reducer;